import {AfterViewChecked, AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@node_modules/@angular/forms';
import {Subscription} from '@models/subscription';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {Store} from '@node_modules/@ngrx/store';
import * as ProgramReducer from '@store/program/reducers';
import * as SubscriptionReducer from '@store/subscription/reducers';
import {AddSubscriptionToProgram, SetSubscriptionToProgram} from '@store/program/actions';
import {Program} from '@models/program';
import * as moment from 'moment';
import {BehaviorSubject} from '@node_modules/rxjs';
import {ExtraFee} from '@models/extra_fee';
import {ErrorResponse} from '@interfaces/responses/error-response';
import {SubscriptionState} from '@store/subscription/reducers';
import {AddSubscription, SetSubscriptions, UpdateSubscription} from '@store/subscription/actions';
import {MatDialog} from '@node_modules/@angular/material';
import {Discount} from '@models/discount';
import {forEach} from '@node_modules/@angular/router/src/utils/collection';
import {SubscriptionTypeService} from '@services/subscriptionType/subscription-type.service';
import {SubscriptionType} from '@models/subscriptionType';
import {User} from '@models/user';
import * as AuthReducer from '@store/auth/reducers';
import {PaymentService} from '@services/payment/payment.service';

@Component({
  selector: 'app-create-program-subscription',
  templateUrl: './create-program-subscription.component.html',
  styleUrls: ['./create-program-subscription.component.scss']
})
export class CreateProgramSubscriptionComponent implements OnInit, AfterViewInit {
  static program: Program;
  static source = 'create';
  static modalRef;
  static allSubscriptions: Subscription[];
  static sourceEdit: Subscription;
  static showCurrentStatusSection = true;
  source = 'create';
  showCurrentStatusSection = true;
  user: User;
  notAdmin = true;
  allSubscriptions: Subscription[];
  allSubscriptionTypes: SubscriptionType[] = [];
  subscriptionDetails: FormGroup;
  subscriptionPaymentsForm: FormGroup;
  subscribes = [];
  programName: string;
  moveMonthsCarousel: BehaviorSubject<string> = new BehaviorSubject(null);
  currentMonth: BehaviorSubject<{month: number, year: number}>
    = new BehaviorSubject<{month: number, year: number}>({month: moment().month() + 1, year: moment().year()});
  currentIndex = 0;
  loading = false;
  info;
  lockinAdditionalConditionalAdded = false;
  pauseAdditionalConditionalAdded = false;
  subscriptionTotalPrice = 0;
  userSubscriptionCancelPrice = 0;
  programLimitedStatus = 'unlimited';
  // currentMonthCarusel = new Date().getMonth() + 1;
  // currentYear = new Date().getFullYear();
  // initSelected = {month: this.currentMonthCarusel, day: this.getDay()};
  // months = [
  //   'January',
  //   'February',
  //   'March',
  //   'April',
  //   'May',
  //   'June',
  //   'July',
  //   'August',
  //   'September',
  //   'October',
  //   'November',
  //   'December',
  // ];
  constructor(
    private fb: FormBuilder,
    private authStore: Store<AuthReducer.AuthState>,
    private subscriptionTypeService: SubscriptionTypeService,
    private subscriptionService: SubscriptionService,
    private paymentService: PaymentService,
    private programStore: Store<ProgramReducer.ProgramState>,
    private subscriptionStore: Store<SubscriptionReducer.SubscriptionState>,
    public dialog: MatDialog,
  ) {
    this.source = CreateProgramSubscriptionComponent.source;
    this.showCurrentStatusSection = CreateProgramSubscriptionComponent.showCurrentStatusSection;

    this.authStore.subscribe(val => {
      const auth = val.auth;
      if (auth && auth.user) {
        this.user = auth.user;
        this.notAdmin = auth.user.notAdmin;
      }
    });
  }

  ngOnInit() {
    if (CreateProgramSubscriptionComponent.sourceEdit) {
      this.info = CreateProgramSubscriptionComponent.sourceEdit;
    }
    if (CreateProgramSubscriptionComponent.allSubscriptions) {
      this.allSubscriptions = CreateProgramSubscriptionComponent.allSubscriptions;
    }
    this.subscriptionDetails = new FormGroup({
      'name': new FormControl( null , [Validators.required]),
      'display_name': new FormControl( null , [Validators.required]),
      'description': new FormControl(null, [Validators.required] ),
      'lockin': new FormControl(false, [Validators.required]),
      'plan_duration_name': new FormControl('day'),
      'plan_duration': new FormControl(null),
      'limited': new FormControl(false, [Validators.required]),
      'attendance_limited': new FormControl(false, [Validators.required]),
      'attendance_value': new FormControl(null),
      'days_left': new FormControl(null),
      'checkins_left': new FormControl(null),
      'trial_status': new FormControl(false, [Validators.required]),
      'on_hold_status': new FormControl(false, [Validators.required]),
      'on_hold_duration_value': new FormControl(0),
      'on_hold_duration_name': new FormControl('days'),
      'on_hold_fee_value': new FormControl(0),
      'on_hold_percent_value': new FormControl(0),
      'on_hold_fee_name_first': new FormControl('money'),
      'on_hold_fee_name_second': new FormControl('money'),
      'trial_duration': new FormControl(0),
      'trial_duration_name': new FormControl('day'),
      'trial_start': new FormControl('first_checkin'),
      'trial_max_amount_check_ins': new FormControl(null),
      'trial_limit_check_ins_status': new FormControl('unLimitedCheckins'),
      'visibility_type': new FormControl('public'),
      'limited_programs': new FormControl(null),
      'limited_programs_status': new FormControl('unlimited'),
      'notice_canceling_value': new FormControl(0),
      'notice_canceling_name': new FormControl('days'),
      'lockin_canceling_name_first': new FormControl('money'),
      'lockin_canceling_name_second': new FormControl('money'),
      'lockin_canceling_money_value': new FormControl(null),
      'lockin_canceling_percent_value': new FormControl(null),
    });
    this.subscriptionPaymentsForm = new FormGroup( {
      'total_price': new FormControl( 0, [Validators.required]),
      'payment_price': new FormControl( 0, [Validators.required]),
      'joining_fee': new FormControl( 0, [Validators.required]),
      'frequency_amount': new FormControl( 1 , [Validators.required]),
      'frequency_name': new FormControl( 'day' , [Validators.required]),
      'discount_status': new FormControl( false , [Validators.required]),
      'discount_value': new FormControl( 0 , ),
      'discount_value_mark': new FormControl( 'money' , ),
      'extra_fees_status': new FormControl( false , [Validators.required]),
      'extra_fees':  this.fb.array([]),
      'discounts':  this.fb.array([]),
      'number_payments': new FormControl( 1 , ),
      'payment_duration_name': new FormControl('until_further_notice'),
      'subscription_type_id': new FormControl(2),
      'limited_checkins_status': new FormControl('unlimited'),
      'check_ins_number': new FormControl(null),
      'auto_renew': new FormControl(false, [Validators.required]),
    });
    if ((CreateProgramSubscriptionComponent.source === 'edit' || CreateProgramSubscriptionComponent.source === 'view') &&
      CreateProgramSubscriptionComponent.sourceEdit.id) {
      this.programName = CreateProgramSubscriptionComponent.sourceEdit.program_name;
      this.setSettings();
    }
    this.getAllSubscriptionTypes();
  }
  ngAfterViewInit() {
    if (CreateProgramSubscriptionComponent.source === 'view') {
      this.setSubscriptionTotalPrice();
      this.setUserSubscriptionCancelPrice();
      $('.create-subscription-wrapper mat-tab-group :input').prop('disabled', true);
      const target = document.getElementById('view-overlay');
      if (target) {
        target.addEventListener('wheel', function(event) {
          const bodys = document.getElementsByClassName('mat-tab-body-content');
          Object.keys(bodys).map(item => {
            const scr = bodys[item].scrollTop += event.wheelDeltaY * -1;
            bodys[item].scrollTo(0, scr);
          });
        });
      }
    }
    if (this.info && this.info.isInvisible()) {
      this.subscriptionPaymentsForm.disable();
      this.subscriptionPaymentsForm.get('frequency_amount').setValue(1);
      Object.keys(this.subscriptionDetails.controls).map(name => {
        if (!this.info.type.updatableRows.includes(name)) {
          this.subscriptionDetails.get(name).disable();
        }
      });
    }
  }
  onCreate() {
    let body = Subscription.create();
    Object.keys(this.subscriptionDetails.controls).map( cntrl => {
      if (!body[cntrl] && cntrl.indexOf('_first') === -1 && cntrl.indexOf('_second') === -1 &&
      cntrl !== 'trial_limit_check_ins_status' &&
      cntrl !== 'limited_programs_status' &&
      cntrl !== 'limited_checkins_status') {
        body[cntrl] = this.subscriptionDetails.controls[cntrl].value;
      }
    });
    Object.keys(this.subscriptionPaymentsForm.controls).map( cntrl => {
      if (!body[cntrl] && cntrl.indexOf('_first') === -1 && cntrl.indexOf('_second') === -1) {
        console.log(cntrl);
        if (cntrl === 'extra_fees') {
          body[cntrl] = [];
          this.subscriptionPaymentsForm.controls[cntrl]['controls'].map(formGroup => {
            const extraFee = new ExtraFee();
            Object.keys(formGroup['controls']).map(cntrli => {
              if (cntrli !== 'id') {
                extraFee[cntrli] = formGroup['controls'][cntrli].value;
              }
            });
            body[cntrl].push(extraFee);
          });
        } else if (cntrl === 'discounts') {
          body[cntrl] = [];
          this.subscriptionPaymentsForm.controls[cntrl]['controls'].map(formGroup => {
            const discount = new Discount();
            Object.keys(formGroup['controls']).map(cntrli => {
              if (cntrli.indexOf('_first') === -1 && cntrli.indexOf('_second') === -1 &&
                cntrli !== 'second_condition_added' &&
                cntrli !== 'id') {
                discount[cntrli] = formGroup['controls'][cntrli].value;
              }
            });
            body[cntrl].push(discount);
          });
        } else if (cntrl !== 'limited_checkins_status') {
          body[cntrl] = this.subscriptionPaymentsForm.controls[cntrl].value;
        }
      }
    });
    // console.log(CreateProgramSubscriptionComponent.source);
    if (CreateProgramSubscriptionComponent.source === 'create') {
      body.program_id = CreateProgramSubscriptionComponent.program ? CreateProgramSubscriptionComponent.program.id : null;
      this.saveNew(body);
    } else if (CreateProgramSubscriptionComponent.source === 'edit') {
      body.id = CreateProgramSubscriptionComponent.sourceEdit.id;
      this.saveExist(body);
    }
  }
  saveExist(body) {
    this.subscribes.push(this.subscriptionService.edit(body).subscribe(
      (resp: {data: Subscription}) => {
        if (CreateProgramSubscriptionComponent.program) {
          this.programStore.dispatch(new AddSubscriptionToProgram({
            subscription: resp.data,
            program_id: CreateProgramSubscriptionComponent.program.id
          }));
        } else {
          this.subscriptionStore.dispatch(new UpdateSubscription(resp.data));
        }
        if (CreateProgramSubscriptionComponent.modalRef) {
          CreateProgramSubscriptionComponent.modalRef.close();
        }
      }
    ));
  }
  async saveNew(body) {
    body.program_id = null;
    this.subscribes.push(this.subscriptionService.create(body).subscribe(
      (resp: {data: any}) => {
        if (CreateProgramSubscriptionComponent.program) {
          this.programStore.dispatch(new SetSubscriptionToProgram({
            subscriptions: resp.data.subscriptions,
            program_id: CreateProgramSubscriptionComponent.program.id
          }));
        } else {
          this.subscriptionStore.dispatch(new AddSubscription(resp.data as Subscription));
        }
        if (CreateProgramSubscriptionComponent.modalRef) {
          CreateProgramSubscriptionComponent.modalRef.close();
        }
      },
      (err: ErrorResponse) => {
        console.log(err);
        Object.keys(err.error.errors).map(item => {
          if (item !== 'avatar') {
            this.subscriptionDetails.controls[item].setErrors({'apiValidate': err.error.errors[item]});
          }
        });
        this.currentIndex = 0;
      }
    ));
  }
  onSelectedPaymentFrequencyName(event) {
    this.subscriptionPaymentsForm.get('frequency_amount').setValue(1);
  }
  onNoticeCancelingName(event) {
    this.subscriptionDetails.get('notice_canceling_value').setValue(0);
  }
  onSelectedLockinCancelationName(event, order) {
    const value = event.value === 'money' ? 'percent' : 'money';
    const controlName = order === 'first' ? 'lockin_canceling_name_second' : 'lockin_canceling_name_first';

    if (!this.lockinAdditionalConditionalAdded) {
      if (value === 'money') {
        this.subscriptionDetails.get('lockin_canceling_money_value').setValue(null);
      } else {
        this.subscriptionDetails.get('lockin_canceling_percent_value').setValue(null);
      }
    }

    this.subscriptionDetails.get(controlName).setValue(value);
  }
  onSelectedPauseName(event, order) {
    const value = event.value === 'money' ? 'percent' : 'money';
    const controlName = order === 'first' ? 'on_hold_fee_name_second' : 'on_hold_fee_name_first';
    this.subscriptionDetails.get(controlName).setValue(value);
  }
  onChangeTrialStart(event) {
    // console.log(event);
    this.subscriptionDetails.get('trial_start').setValue(event.value);
  }
  onExtraFeesstatuschanged(event) {
    // console.log(event);
    // console.log(this.currentIndex);
    if (event.checked === true && (!this.subscriptionPaymentsForm.get('extra_fees') ||
      this.getExtrFees())) {
      this.addEtraFee();
    } else {
      this.subscriptionPaymentsForm.get('extra_fees')['controls'] = [];
    }
  }
  onSelectedPlanDurationName(event) {
    this.subscriptionPaymentsForm.get('plan_duration').setValue(1);
  }
  onSelectedDiscountFeeName(event, discount, orderDiscount) {
    const value = event.value === 'money' ? 'percent' : 'money';
    const controlName = orderDiscount === 'first' ? 'discount_fee_name_second_cond' : 'discount_fee_name_first_cond';
    discount.get(controlName).setValue(value);
    console.log(event, discount);
  }
  deleteSecondCondition(discount) {
    const valueControlName = discount.get('discount_fee_name_second_cond').value === 'money' ? 'money_value' : 'percent_value';
    discount.get(valueControlName).setValue(null);
    discount.get('second_condition_added').setValue(false);
  }
  addSecondCondition(discount) {
    const valueControlName = discount.get('discount_fee_name_first_cond').value === 'money' ? 'percent' : 'money';
    discount.get('discount_fee_name_second_cond').setValue(valueControlName);
    discount.get('second_condition_added').setValue(true);
  }
  onFrequencyAmountChanged(event) {
    const totalPrice = this.subscriptionPaymentsForm.get('total_price').value;
    if (this.subscriptionDetails.get('lockin').value == true &&
      totalPrice > 0
    ) {
      const planDurationName = this.subscriptionDetails.get('plan_duration_name').value;
      const index =  planDurationName === 'week' ? 7 : planDurationName === 'month' ? 30 : planDurationName === 'year' ? 365 : 1;
      const planDurastionDays = this.subscriptionDetails.get('plan_duration').value * index;
      const totalpriceperDay = totalPrice / planDurastionDays;
      const frquencyName = this.subscriptionPaymentsForm.get('frequency_name').value;
      const indexFequency = frquencyName === 'week' ? 7 : frquencyName === 'month' ? 30 : frquencyName === 'year' ? 365 : 1;
      const frequencyDays = event.value * indexFequency;
      const result = Math.round(frequencyDays * totalpriceperDay);
      const paymentPrice = frequencyDays > planDurastionDays ? totalPrice : result;
      if (!isNaN(paymentPrice)) {
        this.subscriptionPaymentsForm.get('payment_price').setValue(paymentPrice);
      }
    }
  }
  onPaymentPriceChanged(event) {
    if (this.subscriptionDetails.get('lockin').value === true) {
      const planDurationName = this.subscriptionDetails.get('plan_duration_name').value;
      const index =  planDurationName === 'week' ? 7 : planDurationName === 'month' ? 30 : planDurationName === 'year' ? 365 : 1;
      const planDurastionDays = this.subscriptionDetails.get('plan_duration').value * index;
      const frquencyName = this.subscriptionPaymentsForm.get('frequency_name').value;
      const indexFequency = frquencyName === 'week' ? 7 : frquencyName === 'month' ? 30 : frquencyName === 'year' ? 365 : 1;
      const frequencyDays = this.subscriptionPaymentsForm.get('frequency_amount').value * indexFequency;
      const totalPrice = Math.round(planDurastionDays / frequencyDays) * event.value;
      if (frequencyDays && !isNaN(totalPrice)) {
        this.subscriptionPaymentsForm.get('total_price').setValue(totalPrice);
      }
    }
  }
  onTrialStatusChanged(event) {
    this.subscriptionDetails.get('trial_status').setValue(event.value);
  }
  onPauseStatusChanged(event) {
    const status = event.value === 'allowedPause';
    this.subscriptionDetails.get('on_hold_status').setValue(status);
  }
  onSelectedExistingSubscription(index) {
    CreateProgramSubscriptionComponent.sourceEdit = this.allSubscriptions[index.value];
    this.subscriptionPaymentsForm.get('extra_fees')['controls'] = [];
    this.setSettings(true);
  }
  onClose() {
    if (CreateProgramSubscriptionComponent.modalRef) {
      CreateProgramSubscriptionComponent.modalRef.close();
    }
  }
  onSelectedMembershipType(event) {
    switch (event.value) {
      case 'limited': {
        this.subscriptionDetails.get('limited_programs').setValue(1);
        break;
      }
      case 'unlimited': {
        this.subscriptionDetails.get('limited_programs').setValue(null);
        break;
      }
    }
  }
  onSelectedCheckInsType(event) {
    switch (event.value) {
      case 'limited': {
        this.subscriptionPaymentsForm.get('check_ins_number').setValue(1);
        break;
      }
      case 'unlimited': {
        this.subscriptionPaymentsForm.get('check_ins_number').setValue(null);
        break;
      }
    }
  }
  triggerLockinAdditional() {
    this.lockinAdditionalConditionalAdded = !this.lockinAdditionalConditionalAdded;
    const value = this.subscriptionDetails.get('lockin_canceling_name_first').value === 'money' ? 'percent' : 'money';
    this.subscriptionDetails.get('lockin_canceling_name_second').setValue(value);
    if (!this.lockinAdditionalConditionalAdded) {
      if (value === 'money') {
        this.subscriptionDetails.get('lockin_canceling_money_value').setValue(null);
      } else {
        this.subscriptionDetails.get('lockin_canceling_percent_value').setValue(null);
      }
    }
  }
  triggerPauseAdditional() {
    this.pauseAdditionalConditionalAdded = !this.pauseAdditionalConditionalAdded;
    const value = this.subscriptionDetails.get('on_hold_fee_name_first').value === 'money' ? 'percent' : 'money';
    this.subscriptionDetails.get('on_hold_fee_name_second').setValue(value);
    if (!this.pauseAdditionalConditionalAdded ) {
      if (value === 'money') {
        this.subscriptionDetails.get('on_hold_fee_value').setValue(null);
      } else {
        this.subscriptionDetails.get('on_hold_percent_value').setValue(null);
      }
    }
  }
  saveExtraFees() {
    if (this.validatePause()) {
      this.onCreate();
    }
  }
  prev(event) {
    this.currentIndex--;
  }
  next() {
    if (this.currentIndex === 0 && this.validateFirstStep()) {
      this.currentIndex++;
    } else if (this.currentIndex === 1 && this.validateSecondStep()) {
      this.currentIndex++;
    } else if (this.getExtrFees().length > 0 && this.currentIndex === 2 && this.validateExtraFees()) {
      this.currentIndex++;
    }  else if (this.getExtrFees().length > 0 && this.currentIndex === 3  || this.getExtrFees().length === 0 && this.currentIndex === 2) {
      this.currentIndex++;
    } else if ((this.getExtrFees().length > 0 ? this.currentIndex === 4  : this.currentIndex === 3) &&
              this.validateTrial()) {
      this.currentIndex++;
    } else if ((this.getExtrFees().length > 0 ? this.currentIndex === 5  : this.currentIndex === 4) &&
              this.validatePause()) {
      console.log('valid');
      this.currentIndex++;
    }
    if (CreateProgramSubscriptionComponent.source === 'view') {
      setTimeout(() => {
        $(".create-subscription-wrapper mat-tab-group :input").prop("disabled", true);
      }, 5);
    }
  }
  validateFirstStep() {
    if (!this.subscriptionDetails.get('name').value || this.subscriptionDetails.get('name').value.length <= 0) {
      this.subscriptionDetails.get('name').markAsTouched();
      this.subscriptionDetails.get('name').setErrors({'required': true});
      return false;
    }
    if (!this.subscriptionDetails.get('display_name').value || this.subscriptionDetails.get('display_name').value.length <= 0) {
      this.subscriptionDetails.get('display_name').markAsTouched();
      this.subscriptionDetails.get('display_name').setErrors({'required': true});
      return false;
    }
    if (!this.subscriptionDetails.get('description').value || this.subscriptionDetails.get('description').value.length <= 0) {
      this.subscriptionDetails.get('description').markAsTouched();
      this.subscriptionDetails.get('description').setErrors({'required': true});
      return false;
    }
    if (this.subscriptionDetails.get('lockin').value) {
      console.log(this.subscriptionDetails.get('plan_duration').value);
       if (!this.subscriptionDetails.get('plan_duration').value || this.subscriptionDetails.get('plan_duration').value <= 0) {
         this.subscriptionDetails.get('plan_duration').markAsTouched();
         this.subscriptionDetails.get('plan_duration').setErrors({'required': true});
         return false;
       }
    } else {
      if (typeof this.subscriptionDetails.get('notice_canceling_value').value === undefined ||
          typeof this.subscriptionDetails.get('notice_canceling_value').value === null ||
          this.subscriptionDetails.get('notice_canceling_value').value < 0) {
            this.subscriptionDetails.get('notice_canceling_value').markAsTouched();
            this.subscriptionDetails.get('notice_canceling_value').setErrors({'required': true});
        return false;
      }
    }
    return true;
  }
  validateSecondStep() {
    if (typeof this.subscriptionPaymentsForm.get('payment_price').value === undefined ||
      typeof this.subscriptionPaymentsForm.get('payment_price').value === null ||
      this.subscriptionPaymentsForm.get('payment_price').value < 0) {
      this.subscriptionPaymentsForm.get('payment_price').markAsTouched();
      this.subscriptionPaymentsForm.get('payment_price').setErrors({'required': true});
      return false;
    }
    if (typeof this.subscriptionPaymentsForm.get('joining_fee').value === undefined ||
      typeof this.subscriptionPaymentsForm.get('joining_fee').value === null) {
      this.subscriptionPaymentsForm.get('joining_fee').markAsTouched();
      this.subscriptionPaymentsForm.get('joining_fee').setErrors({'required': true});
      return false;
    }
    if (!this.subscriptionPaymentsForm.get('frequency_amount').value ||
      this.subscriptionPaymentsForm.get('frequency_amount').value <= 0) {
      this.subscriptionPaymentsForm.get('frequency_amount').markAsTouched();
      this.subscriptionPaymentsForm.get('frequency_amount').setErrors({'required': true});
      return false;
    }
    return true;
  }
  validateExtraFees() {
    return this.subscriptionPaymentsForm.get('extra_fees')['controls'].filter( extr => {
      if (extr.get('delete') && extr.get('delete').value) {
        return false;
      }
      if (!extr.get('extra_fees_name').value || extr.get('extra_fees_name').value.legth === 0) {
        extr.get('extra_fees_name').markAsTouched();
        extr.get('extra_fees_name').setErrors({'required': true});
        return false;
      }
      if (!extr.get('extra_fees_price').value || extr.get('extra_fees_price').value <= 0) {
        extr.get('extra_fees_price').markAsTouched();
        extr.get('extra_fees_price').setErrors({'required': true});
        return false;
      }
      if (!extr.get('frequency_value').value || extr.get('frequency_value').value <= 0) {
        extr.get('frequency_value').markAsTouched();
        extr.get('frequency_value').setErrors({'required': true});
        return false;
      }
      return true;
    }).length === this.getExtrFees().length;
  }
  validateTrial() {
    if (this.subscriptionDetails.get('trial_status').value) {
      const trial_duration = this.subscriptionDetails.get('trial_duration');
      const trial_max_amount_check_ins = this.subscriptionDetails.get('trial_max_amount_check_ins');
      const trial_limit_check_ins_status = this.subscriptionDetails.get('trial_limit_check_ins_status');

      if (trial_duration.value <= 0 && trial_limit_check_ins_status.value !== 'limitedCheckins') {
        trial_duration.markAsTouched();
        trial_duration.setErrors({'required': true});
        return false;
      }
      if (trial_limit_check_ins_status.value === 'limitedCheckins') {
        if (trial_max_amount_check_ins.value <= 0) {
          trial_max_amount_check_ins.markAsTouched();
          trial_max_amount_check_ins.setErrors({'required': true});
          return false;
        }
      }
    }
    return true;
  }
  validatePause() {
    if (this.subscriptionDetails.get('on_hold_status').value) {
      if (this.subscriptionDetails.get('on_hold_duration_value').value <= 0) {
        this.subscriptionDetails.get('on_hold_duration_value').markAsTouched();
        this.subscriptionDetails.get('on_hold_duration_value').setErrors({'required': true});
        return false;
      }
    }
    return true;
  }
  firstCharUpperCase(string) {
    return string[0].toUpperCase() + string.substring(1);
  }
  // onMonthToRight() {
  //   this.currentMonthCarusel -= 1;
  //   console.log(this.currentMonthCarusel, 'right');
  //   if (this.currentMonthCarusel < 1) {
  //     this.currentYear--;
  //     this.currentMonthCarusel = 12;
  //   }
  //   this.moveMonthsCarousel.next('right');
  //   this.currentMonth.next({month: this.currentMonthCarusel, year: this.currentYear});
  // }
  //
  // onMonthToLeft() {
  //   this.currentMonthCarusel += 1;
  //   console.log(this.currentMonthCarusel, 'left');
  //   if (this.currentMonthCarusel > 12) {
  //     this.currentYear++;
  //     this.currentMonthCarusel = 1;
  //   }
  //   this.moveMonthsCarousel.next('left');
  //   this.currentMonth.next({month: this.currentMonthCarusel, year: this.currentYear});
  // }
  // onSelectedDay(event) {
  //   if (event.initDay === true) {
  //     this.initSelected = null;
  //   }
  //   console.log(event);
  //   this.subscriptionDetails.get('trial_start_day').setValue(moment().month(this.currentMonthCarusel).date(event.day).format('YYYY-MM-DD'));
  // }
  scrollBottom() {
    setTimeout(() => {
      const tbBody = document.getElementsByClassName('mat-tab-body-content');
      if (tbBody) {
        if (this.currentIndex === 0 && tbBody.item(0)) {
          tbBody.item(0).scrollTop = tbBody.item(0).scrollHeight;
        }
        if (this.currentIndex === 1 && tbBody.item(1)) {
          tbBody.item(1).scrollTop = tbBody.item(1).scrollHeight;
        }
      }
    }, 50);
  }

  parsePrice(price) {
    return parseFloat(price);
  }

  parseIntervalType(interval, value = 1) {
    return value > 1 ? interval + 's' : interval;
  }

  addEtraFee(extraFee: ExtraFee = null) {
    console.log(this.subscriptionPaymentsForm.get('extra_fees'));
    if (extraFee) {
      this.subscriptionPaymentsForm.get('extra_fees')['controls'].push(this.fb.group({
        'extra_fees_name': new FormControl(extraFee.extra_fees_name, [Validators.required]),
        'extra_fees_price': new FormControl(extraFee.extra_fees_price, [Validators.required]),
        'frequency_name': new FormControl(extraFee.frequency_name, [Validators.required]),
        'frequency_value': new FormControl(extraFee.frequency_value, [Validators.required]),
        'uuid': new FormControl((new Date().getTime()).toString(36), [Validators.required]),
        'extra_fee_id': new FormControl(CreateProgramSubscriptionComponent.source === 'edit' ? extraFee.id : null),
        'delete': new FormControl(false, [Validators.required]),
      }));
    } else {
      this.subscriptionPaymentsForm.get('extra_fees')['controls'].push(this.fb.group({
        'extra_fees_name': new FormControl(null, [Validators.required]),
        'uuid': new FormControl((new Date().getTime()).toString(36), [Validators.required]),
        'extra_fees_price': new FormControl(null, [Validators.required]),
        'frequency_name': new FormControl('day', [Validators.required]),
        'frequency_value': new FormControl(1, [Validators.required]),
      }));
    }
    // console.log(this.subscriptionPaymentsForm);
  }
  addDiscount(discount: Discount = null) {
    if (!this.info || !this.info.isInvisible()) {
      if (discount) {
        this.subscriptionPaymentsForm.get('discounts')['controls'].push(this.fb.group({
          'number_of_members': new FormControl(discount.number_of_members),
          'discount_fee_name_first_cond': new FormControl(discount.money_value ? 'money' : 'percent'),
          'discount_fee_name_second_cond': new FormControl(discount.percent_value ? 'percent' : 'money'),
          'money_value': new FormControl(discount.money_value),
          'percent_value': new FormControl(discount.percent_value),
          'second_condition_added': new FormControl(!!discount.money_value && !!discount.percent_value),
          'id': null
        }));
      } else {
        this.subscriptionPaymentsForm.get('discounts')['controls'].push(this.fb.group({
          'number_of_members': new FormControl(null),
          'discount_fee_name_first_cond': new FormControl('money'),
          'discount_fee_name_second_cond': new FormControl('percent'),
          'money_value': new FormControl(null),
          'percent_value': new FormControl(null),
          'second_condition_added': new FormControl(false),
          'id': null
        }));
      }
    }
  }
  removeDiscount(index) {
    Object.keys(this.subscriptionPaymentsForm.get('discounts')['controls']).map( (discount, i) => {
      if (i === index) {
        this.subscriptionPaymentsForm.get('discounts')['controls'].splice(i, 1);
      }
    });
  }
  deleteExtraFee(i) {
    this.subscriptionPaymentsForm.get('extra_fees')['controls'].map( (extrFee, y) => {
      if (extrFee.get('uuid').value === i) {
        if (this.getExtrFees().length === 1) {
          this.addEtraFee();
        }
        if (this.subscriptionPaymentsForm.get('extra_fees')['controls'][y].get('extra_fee_id') &&
          this.subscriptionPaymentsForm.get('extra_fees')['controls'][y].get('extra_fee_id').value) {
          this.subscriptionPaymentsForm.get('extra_fees')['controls'][y].get('delete').setValue(true);
        } else {
          this.subscriptionPaymentsForm.get('extra_fees')['controls'].splice(y, 1);
        }
      }
    });
  }
  getExtrFees() {
    let res = [];
    Object.keys(this.subscriptionPaymentsForm.get('extra_fees')['controls']).map( extr => {
      if (!this.subscriptionPaymentsForm.get('extra_fees')['controls'][extr].get('delete') ||
        this.subscriptionPaymentsForm.get('extra_fees')['controls'][extr].get('delete').value === false) {
        res.push(this.subscriptionPaymentsForm.get('extra_fees')['controls'][extr]);
      }
    });
    return res;
  }
  getDiscounts() {
    let res = [];
    if (Object.keys(this.subscriptionPaymentsForm.get('discounts')['controls']).length === 0) {
      this.addDiscount();
    }
    Object.keys(this.subscriptionPaymentsForm.get('discounts')['controls']).map( discount => {
      if (!this.subscriptionPaymentsForm.get('discounts')['controls'][discount].get('delete') ||
        this.subscriptionPaymentsForm.get('discounts')['controls'][discount].get('delete').value === false) {
        res.push(this.subscriptionPaymentsForm.get('discounts')['controls'][discount]);
      }
    });
    return res;
  }
  setSettings(fromExisting = false) {
    this.subscriptionDetails.patchValue(CreateProgramSubscriptionComponent.sourceEdit as {[key: string]: any});
    if (fromExisting === true) {
      if (this.subscriptionDetails.get('name').value && this.subscriptionDetails.get('name').value.length > 0) {
        this.subscriptionDetails.get('name').setValue(this.subscriptionDetails.get('name').value + ' - copy');
      }
      if (this.subscriptionDetails.get('display_name').value && this.subscriptionDetails.get('display_name').value.length > 0) {
        this.subscriptionDetails.get('display_name').setValue(this.subscriptionDetails.get('display_name').value + ' - copy');
      }
    }
    if (this.subscriptionDetails.get('limited_programs').value && this.subscriptionDetails.get('limited_programs').value > 0) {
      this.subscriptionDetails.get('limited_programs_status').setValue('limited');
    }
    if (this.subscriptionDetails.get('lockin_canceling_money_value').value
      && this.subscriptionDetails.get('lockin_canceling_money_value').value > 0
      && this.subscriptionDetails.get('lockin_canceling_percent_value').value
      && this.subscriptionDetails.get('lockin_canceling_percent_value').value > 0) {
        this.subscriptionDetails.get('lockin_canceling_name_first').setValue('money');
        this.subscriptionDetails.get('lockin_canceling_name_second').setValue('percent');
        this.lockinAdditionalConditionalAdded = true;
    } else {
      if (this.subscriptionDetails.get('lockin_canceling_money_value').value
        && this.subscriptionDetails.get('lockin_canceling_money_value').value > 0) {
        this.subscriptionDetails.get('lockin_canceling_name_first').setValue('money');
      }
      if (this.subscriptionDetails.get('lockin_canceling_percent_value').value
        && this.subscriptionDetails.get('lockin_canceling_percent_value').value > 0) {
        this.subscriptionDetails.get('lockin_canceling_name_first').setValue('percent');
      }
    }
    this.subscriptionPaymentsForm.patchValue(CreateProgramSubscriptionComponent.sourceEdit as {[key: string]: any});
    if (CreateProgramSubscriptionComponent.sourceEdit.subscription_type && CreateProgramSubscriptionComponent.sourceEdit.subscription_type.id) {
      this.subscriptionPaymentsForm.get('subscription_type_id').setValue(CreateProgramSubscriptionComponent.sourceEdit.subscription_type.id);
    }
    if (this.subscriptionPaymentsForm.get('check_ins_number').value && this.subscriptionPaymentsForm.get('check_ins_number').value > 0) {
      this.subscriptionPaymentsForm.get('limited_checkins_status').setValue('limited');
    }
    if (this.subscriptionDetails.get('trial_max_amount_check_ins').value
      && this.subscriptionDetails.get('trial_max_amount_check_ins').value > 0) {
      this.subscriptionDetails.get('trial_limit_check_ins_status').setValue('limitedCheckins');
    } else {
      this.subscriptionDetails.get('trial_limit_check_ins_status').setValue('unlimitedCheckins');
    }
    if (this.subscriptionDetails.get('on_hold_fee_value').value && this.subscriptionDetails.get('on_hold_fee_value').value > 0 &&
      !this.subscriptionDetails.get('on_hold_percent_value').value || this.subscriptionDetails.get('on_hold_percent_value').value === 0) {
      this.subscriptionDetails.get('on_hold_fee_name_first').setValue('money');
    } else {
      this.subscriptionDetails.get('on_hold_fee_name_first').setValue('percent');
    }
    if (this.subscriptionDetails.get('on_hold_fee_value').value && this.subscriptionDetails.get('on_hold_fee_value').value > 0 &&
      this.subscriptionDetails.get('on_hold_percent_value').value && this.subscriptionDetails.get('on_hold_percent_value').value > 0) {
      this.pauseAdditionalConditionalAdded = true;
      this.subscriptionDetails.get('on_hold_fee_name_second')
        .setValue(this.subscriptionDetails.get('on_hold_fee_name_first').value === 'percent' ? 'money' : 'percent');
    } else {
      this.pauseAdditionalConditionalAdded = false;
    }
    if (CreateProgramSubscriptionComponent.sourceEdit.extra_fees && CreateProgramSubscriptionComponent.sourceEdit.extra_fees.length > 0) {
      CreateProgramSubscriptionComponent.sourceEdit.extra_fees.map( extraFee => {
        this.addEtraFee(extraFee);
      });
    }
    if (CreateProgramSubscriptionComponent.sourceEdit.discounts && CreateProgramSubscriptionComponent.sourceEdit.discounts.length > 0) {
      CreateProgramSubscriptionComponent.sourceEdit.discounts.map( discount => {
        this.addDiscount(discount);
      });
    } else {
      this.addDiscount();
    }
    console.log(this.subscriptionPaymentsForm);
  }
  subscriptionNameChanged(input) {
    if (!this.subscriptionDetails.get('display_name').value || this.subscriptionDetails.get('display_name').value.length === 0 || !this.subscriptionDetails.get('display_name').dirty) {
      this.subscriptionDetails.get('display_name').setValue(input.value);
    }
  }
  close() {
    CreateProgramSubscriptionComponent.showCurrentStatusSection = true;
    this.dialog.closeAll();
  }
  checkValue(event) {
    if (event.target.value) {
      const value = parseFloat(event.target.value);
      event.target.value = value === 0 || isNaN(value) ? 1 : value;
    }
    if (this.subscriptionPaymentsForm.get(event.target.name)) {
      this.subscriptionPaymentsForm.get(event.target.name).setValue(event.target.value);
    }
    if (this.subscriptionDetails.get(event.target.name)) {
      this.subscriptionDetails.get(event.target.name).setValue(event.target.value);
    }
  }
  getAllSubscriptionTypes() {
    this.subscriptionTypeService.getAllSubscriptionTypes().subscribe(
      (resp: {data: SubscriptionType[]}) => {
        this.allSubscriptionTypes = resp.data;
        setTimeout(() => {
          if (!this.subscriptionPaymentsForm.get('subscription_type_id').value) {
            this.subscriptionPaymentsForm.get('subscription_type_id').setValue(this.allSubscriptionTypes[0].id);
          }
        }, 10);
      }
    );
  }
  getSelectedSubscriptionTypeName() {
    let selectedName = '';
    if (this.allSubscriptionTypes && this.allSubscriptionTypes.length > 0) {
      this.allSubscriptionTypes.map(i => {
        if (i.id === this.subscriptionPaymentsForm.get('subscription_type_id').value) {
          selectedName = i.name;
        }
      });
      if (selectedName.length === 0) {
        console.error('Selected subscription name was not fodud');
      }
    }
    return selectedName;
  }

  setSubscriptionTotalPrice() {
    if (this.info.id) {
      this.paymentService
        .getTotalPrice(this.info.id)
        .subscribe((resp: {data: number}) => {
          this.subscriptionTotalPrice = resp.data;
        });
    }
  }

  setUserSubscriptionCancelPrice() {
    if (this.info && this.info.userId && this.info.userSubscriptionId) {
      this.paymentService
        .getCancelPrice(this.info.userId, this.info.userSubscriptionId)
        .subscribe((resp: {data: number}) => {
          this.userSubscriptionCancelPrice = resp.data;
        });
    }
  }
}
